import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalHabilitacion } from '../../types/PersonalHabilitacion';

interface PersonalHabilitacionState {
    personalList: PersonalHabilitacion[];
    personalSelected: PersonalHabilitacion;
    loading: boolean;
}

export const personalHabilitacionInitial: PersonalHabilitacion = {
    id: 0,
    apellido: '',
    nombre: '',
    idTipoDocPersona: 0,
    tipoDocPersona: '',
    nroDocumento: '',
    situacionContractual: '',
    idHabilitacionContratista: 0,
    activo: true,
};

const initialState: PersonalHabilitacionState = {
    personalList: [],
    personalSelected: personalHabilitacionInitial,
    loading: false,
};

const personalHabilitacionSlice = createSlice({
    name: 'personalHabilitacion',
    initialState,
    reducers: {
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        setPersonalList: (state, action: PayloadAction<PersonalHabilitacion[]>) => {
            state.personalList = action.payload;
            state.loading = false;
        },
        loadDataPersonal: (state, action: PayloadAction<PersonalHabilitacion>) => {
            state.personalSelected = action.payload;
        },
        clearPersonalSelected: (state) => {
            state.personalSelected = personalHabilitacionInitial;
        },
    },
});

export const { isLoading, setPersonalList, loadDataPersonal, clearPersonalSelected } = personalHabilitacionSlice.actions;
export default personalHabilitacionSlice.reducer;
